import React from 'react'
import styled from "@emotion/styled/macro"
import { theme, device } from "./Theme"

const HeaderTextBottom = (props) =>{
    const HeaderText = styled.div`
    
      background-color: ${theme.colors.primary};
      color: ${theme.colors.light};
      font-family: ${theme.fonts.altFont};
      font-size: clamp(0.75rem, -0.1618rem + 1.4706vw, 1.125rem);
      letter-spacing: 1px;
      text-transform: uppercase;
      padding: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: clamp(1.25rem, 1.0680rem + 0.7767vw, 2rem);

      .headerTextColored{
        color: ${theme.colors.secondary};
      }
      
      @media ${device.lg}{
        grid-column: 1 / span 3;
      }
    `
    return(
        <HeaderText>
        <p>
          <span className="headerTextColored">{props.headerData.textColored}</span> {props.headerData.textWhite}
        </p>
      </HeaderText>
    )
}
export {HeaderTextBottom}
